import Components from "./components";
import Dialog from "./dialog";
import Help from "./help";

const ModuleName = "tfApp.om";

export default angular.module(ModuleName, [Components(ModuleName), Dialog(ModuleName), Help(ModuleName)])
                      .name;
